module.exports = __webpack_public_path__ + "static/img/Amiss.238cc38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Amiss.jpg
// module id = baCE
// module chunks = 0